'use client'
import { WalletsView } from '../../views/WalletsView/WalletsView.js';
import { ProfileView } from '../../views/ProfileView/ProfileView.js';
import { EditProfileView } from '../../views/EditProfileView/EditProfileView.js';
import { SendBalanceWidgetView } from '../../views/SendBalanceWidgetView/SendBalanceWidgetView.js';
import { ManagePasskeysWidgetView } from '../../views/ManagePasskeysWidgetView/ManagePasskeysWidgetView.js';
import { SettingsView } from '../../views/SettingsView/SettingsView.js';
import { ChooseWalletFundingMethod } from '../../views/ChooseWalletFundingMethod/ChooseWalletFundingMethod.js';
import { ConnectedAppsView } from '../../views/ConnectedAppsView/ConnectedAppsView.js';
import { DepositView } from '../../views/DepositView/DepositView.js';
import { GlobalWalletView } from '../../views/GlobalWalletView/GlobalWalletView.js';
import { ManageMfaWidgetView } from '../../views/ManageMfaWidgetView/ManageMfaWidgetView.js';
import { ReceiveExternalWalletFunds } from '../../views/ReceiveExternalWalletFunds/ReceiveExternalWalletFunds.js';

const mapViewToComponent = {
    'choose-wallet-funding-method': ChooseWalletFundingMethod,
    'connected-apps': ConnectedAppsView,
    'deposit-view': DepositView,
    'edit-profile': EditProfileView,
    'global-wallet': GlobalWalletView,
    'manage-mfa': ManageMfaWidgetView,
    'manage-passkeys': ManagePasskeysWidgetView,
    profile: ProfileView,
    'receive-external-wallet-funds': ReceiveExternalWalletFunds,
    'send-balance': SendBalanceWidgetView,
    settings: SettingsView,
    wallets: WalletsView,
};

export { mapViewToComponent };
